import React from "react";
import arrow from "../assets/images/location-modal/arrow-right.png";
import cancel from "../assets/images/navbar/cancel.png";
import info from "../assets/images/navbar/information.png";
import help from "../assets/images/navbar/help.png";
import sales from "../assets/images/navbar/sales.png";
import clock from "../assets/images/clock.png"
import discount from "../assets/images/discount.png"
import complain from "../assets/images/complain.png"
import payout from "../assets/images/payout.png"

import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import OutletInfo from "./OutletInfo";
import OutletTiming from "./OutletTiming";
import ManageCommunication from "./ManageCommunication";
import SheduleOffKitchen from "./SheduleOffKitchen";
import ReviewsAndComplain from "./ReviewsAndComplain";
import OrderHistory from "./OrderHistory";
import Payout from "./Payout";
import SalesReport from "./SalesReport";
import HelpAndSupport from "./HelpAndSupport";
import Coupons from "./Coupons";
import StaticContentPage from "./StaticContentPage";
import FAQs from "./FAQs";
import AboutUs from "./AboutUs";
import { StaticPageSlug } from "../utils/types";

type ProfileProps = {
  setIsUserModalOpen: (open: boolean) => void;
};

const Profile = ({ setIsUserModalOpen }: ProfileProps) => {
  const navigate = useNavigate();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const [isOutletInfoOpen, setIsOutletInfoOpen] = React.useState(false);
  const [isOutletTimingOpen, setIsOutletTimingOpen] = React.useState(false);
  const [isManageCommunicationOpen, setIsManageCommunicationOpen] = React.useState(false);
  const [isSheduleOffKitchenOpen, setIsSheduleOffKitchenOpen] = React.useState(false);
  const [isReviewsAndComplainOpen, setIsReviewsAndComplainOpen] = React.useState(false);
  const [isOrderHistoryOpen, setIsOrderHistoryOpen] = React.useState(false);
  const [isPayoutOpen, setIsPayoutOpen] = React.useState(false);
  const [isSalesReportOpen, setIsSalesReportOpen] = React.useState(false);
  const [isHelpAndSupportOpen, setIsHelpAndSupportOpen] = React.useState(false);
  const [isCouponsOpen, setIsCouponsOpen] = React.useState(false);
  const [isFaqsOpen, setIsFaqsOpen] = React.useState(false);
  const [isAboutOpen, setIsAboutOpen] = React.useState(false);
  const [staticPage, setStaticPage] = React.useState<{ slug: StaticPageSlug; title: string } | null>(null);

  // Menu items organized by sections
  const manageOutletItems = [
    { 
      icon: info, 
      label: "Outlet Information", 
      onClick: () => setIsOutletInfoOpen(true)
    },
    { 
      icon: clock, 
      label: "Outlet Timings", 
      onClick: () => setIsOutletTimingOpen(true)
    },
    { icon: discount, label: "Discounts and Coupons", onClick: () => setIsCouponsOpen(true) },
  ];

  const settingsItems = [
    { icon: info, label: "Manage Communications", onClick: () => setIsManageCommunicationOpen(true) },
    { icon: clock, label: "Schedule Off Kitchen", onClick: () => setIsSheduleOffKitchenOpen(true) },
  ];

  const ordersReportsItems = [
    { icon: info, label: "Orders History", onClick: () => setIsOrderHistoryOpen(true) },
    { icon: complain, label: "Reviews and Complaints", onClick: () => setIsReviewsAndComplainOpen(true) },
    { icon: payout, label: "Payouts", onClick: () => setIsPayoutOpen(true) },
    {
      icon: sales,
      label: "Sales Report",
      onClick: () => setIsSalesReportOpen(true),
    },
  ];

  const helpItems = [
    {
      icon: help,
      label: "Help Center",
      onClick: () => setIsHelpAndSupportOpen(true),
    },
    {
      icon: info,
      label: "Terms and Conditions",
      onClick: () =>
        setStaticPage({
          slug: "kitchen-partner-terms-conditions",
          title: "Terms and Conditions",
        }),
    },
    {
      icon: help,
      label: "FAQs",
      onClick: () => setIsFaqsOpen(true),
    },
    {
      icon: info,
      label: "About Us",
      onClick: () => setIsAboutOpen(true),
    },
    {
      icon: info,
      label: "Privacy Policy",
      onClick: () =>
        setStaticPage({
          slug: "kitchen-partner-privacy-policy",
          title: "Privacy Policy",
        }),
    },
    {
      icon: clock,
      label: "Dark Mode",
      isDarkMode: true,
      onClick: () => {},
    },
    {
      icon: cancel,
      label: "Sign Out",
      onClick: () => {
        // Handle sign out logic here
        localStorage.removeItem('kitchenAuthToken');
        localStorage.removeItem('kitchenRegistered');
        setIsUserModalOpen(false);
        navigate('/');
        window.location.reload();
      },
    },
  ];

  const renderMenuItem = (item: any, index: number, arrayLength: number) => (
    <div key={index}>
      <div
        className="flex justify-between items-center py-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors px-2"
        onClick={item.isDarkMode ? undefined : item.onClick}
      >
        <div className="flex items-center gap-3">
          <img src={item.icon} alt={item.label} className="h-5 w-5 dark:invert" />
          <span className="text-[#040404] dark:text-gray-200 font-Urbanist text-[16px] font-normal leading-[20px]">
            {item.label}
          </span>
        </div>
        {item.isDarkMode ? (
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isDarkMode}
              onChange={toggleDarkMode}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-orange-500"></div>
          </label>
        ) : (
          <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
        )}
      </div>
      {index < arrayLength - 1 && (
        <div className="h-[1px] w-full bg-gray-200 dark:bg-gray-700"></div>
      )}
    </div>
  );

  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300"
        onClick={() => setIsUserModalOpen(false)}
      >
        <div
          className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 shadow-2xl transform transition-transform duration-300 ease-in-out rounded-l-[20px] p-6 overflow-y-auto"
          style={{ animation: "slideInRight 0.3s ease-out" }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div className="flex justify-between items-center mb-6">
            <img
              src={cancel}
              alt="close"
              className="w-[36px] h-[36px] p-[7.5px] rounded-full border-[0.75px] border-[rgba(112,107,102,0.25)] bg-[rgba(255,255,255,0.25)] cursor-pointer"
              onClick={() => setIsUserModalOpen(false)}
            />
          </div>

          {/* Modal Content */}
          <div className="space-y-4">
            {/* Manage Outlet Section */}
            <div className="border dark:border-gray-700 rounded-[16px] p-4">
              <h2 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[18px] font-semibold leading-[140%] border-b dark:border-gray-700 pb-3">
                Manage Outlet
              </h2>
              <div className="">
                {manageOutletItems.map((item, index) =>
                  renderMenuItem(item, index, manageOutletItems.length)
                )}
              </div>
            </div>

            {/* Settings Section */}
            <div className="border dark:border-gray-700 rounded-[16px] p-4">
              <h2 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[20px] font-semibold leading-[140%] border-b dark:border-gray-700 pb-3">
                Settings
              </h2>
              <div className="">
                {settingsItems.map((item, index) =>
                  renderMenuItem(item, index, settingsItems.length)
                )}
              </div>
            </div>

            {/* Orders & Reports Section */}
            <div className="border dark:border-gray-700 rounded-[16px] p-4">
              <h2 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[20px] font-semibold leading-[140%] border-b dark:border-gray-700 pb-3">
                Orders & Reports
              </h2>
              <div className="">
                {ordersReportsItems.map((item, index) =>
                  renderMenuItem(item, index, ordersReportsItems.length)
                )}
              </div>
            </div>

            {/* Help Section */}
            <div className="border dark:border-gray-700 rounded-[16px] p-4">
              <h2 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[20px] font-semibold leading-[140%] border-b dark:border-gray-700 pb-3">
                Help
              </h2>
              <div className="">
                {helpItems.map((item, index) =>
                  renderMenuItem(item, index, helpItems.length)
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Outlet Info Modal */}
      {isOutletInfoOpen && (
        <OutletInfo setIsOutletInfoOpen={setIsOutletInfoOpen} />
      )}

      {/* Outlet Timing Modal */}
      {isOutletTimingOpen && (
        <OutletTiming setIsOutletTimingOpen={setIsOutletTimingOpen} />
      )}

      {/* Manage Communication Modal */}
      {isManageCommunicationOpen && (
        <ManageCommunication setIsManageCommunicationOpen={setIsManageCommunicationOpen} />
      )}

      {/* Schedule Off Kitchen Modal */}
      {isSheduleOffKitchenOpen && (
        <SheduleOffKitchen setIsSheduleOffKitchenOpen={setIsSheduleOffKitchenOpen} />
      )}

      {/* Reviews and Complain Modal */}
      {isReviewsAndComplainOpen && (
        <ReviewsAndComplain setIsReviewsAndComplainOpen={setIsReviewsAndComplainOpen} />
      )}

      {/* Order History Modal */}
      {isOrderHistoryOpen && (
        <OrderHistory setIsOrderHistoryOpen={setIsOrderHistoryOpen} />
      )}

      {/* Payout Modal */}
      {isPayoutOpen && (
        <Payout setIsPayoutOpen={setIsPayoutOpen} />
      )}

      {/* Sales Report Modal */}
      {isSalesReportOpen && (
        <SalesReport setIsSalesReportOpen={setIsSalesReportOpen} />
      )}

      {/* Help and Support Modal */}
      {isHelpAndSupportOpen && (
        <HelpAndSupport setIsHelpAndSupportOpen={setIsHelpAndSupportOpen} />
      )}

      {isCouponsOpen && <Coupons setIsCouponsOpen={setIsCouponsOpen} />}

      {isFaqsOpen && <FAQs onClose={() => setIsFaqsOpen(false)} />}

      {isAboutOpen && <AboutUs onClose={() => setIsAboutOpen(false)} />}

      {staticPage && (
        <StaticContentPage
          slug={staticPage.slug}
          title={staticPage.title}
          onClose={() => setStaticPage(null)}
        />
      )}
    </div>
  );
};

export default Profile;
